export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_10.0ab1a624.jpg";